const getBaseDashboardSearchUrl = (searchTerm: string) => `/dashboard/search/${encodeURIComponent(searchTerm)}`;
const getAdminDashboardSearchUrl = getBaseDashboardSearchUrl;
const getUserDashboardSearchUrl = (companyId: string, searchTerm: string) =>
  `/companies/${companyId}${getBaseDashboardSearchUrl(searchTerm)}`;

export default {
  getAdminDashboardSearchUrl,
  getUserDashboardSearchUrl,
};
